import './App.css';
import './index.css';
import { useEffect, useState, useRef } from 'react';
import {
  Calendar,
  Sparkles,
  Heart,
  ChevronDown,
  Globe,
  ChevronRight,
} from 'lucide-react';
import florLogo from './assets/florDaisiesSF.png';
import letrasLogo from './assets/daisies_letras.png';
import TopBanner from './components/TopBanner';
import ScheduleSection from './components/ScheduleSection';


/* ─── Platform detection ─── */
function getPlatform() {
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'unknown';
}

/* ─── App Store SVG Icon ─── */
function AppleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 384 512" fill="currentColor">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
    </svg>
  );
}

/* ─── Google Play SVG Icon ─── */
function PlayStoreIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
      <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
    </svg>
  );
}

/* ─── Social SVG Icons ─── */
function InstagramIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <circle cx="12" cy="12" r="5"/>
      <circle cx="17.5" cy="6.5" r="1.5"/>
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V9.05a8.16 8.16 0 004.76 1.52v-3.4a4.85 4.85 0 01-1-.48z"/>
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
}

const videoUrl =
  'https://firebasestorage.googleapis.com/v0/b/daisies-70154.appspot.com/o/imgs%2FVideo%20cli%CC%81nica%20digital%20mejorado.mov?alt=media&token=44807186-3511-4a0c-9b52-153c257809a2';

function App() {
  const [platform, setPlatform] = useState('unknown');
  const [isPlaying, setIsPlaying] = useState(false);
  const videoSectionRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    setPlatform(getPlatform());
  }, []);

  const showIos = platform === 'ios' || platform === 'unknown';
  const showAndroid = platform === 'android' || platform === 'unknown';

  const scrollToVideo = () => {
    videoSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handlePlayPause = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="min-h-screen bg-white relative overflow-hidden">
<TopBanner />

      {/* ─── Decorative background ─── */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-gradient-to-br from-daisies/5 to-transparent rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] bg-gradient-to-tl from-daisies/5 to-transparent rounded-full blur-3xl pointer-events-none" />

      {/* ════════════════════════════════════════════════
          SECTION 1 — Links
       ════════════════════════════════════════════════ */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-5 py-8">
        <div className="w-full max-w-sm flex flex-col items-center gap-4">

          {/* ─── Logo + Slogan ─── */}
          <div className="flex flex-col items-center gap-2 animate-fadeInUp">
            <img src={florLogo} alt="Daisies" className="h-14 w-auto" />
            <img src={letrasLogo} alt="Daisies" className="h-6 w-auto" />
            <p className="text-sm text-text-secondary font-medium text-center">
              Tu clínica digital en tus manos
            </p>
          </div>

          {/* ─── Download Button (full-width, contextual) ─── */}
          <div className="w-full animate-fadeInUp-1">
            {showIos && (
              <a
                href="https://apps.apple.com/mx/app/daisies/id1608605255?l=en-GB"
                target="_blank"
                rel="noopener noreferrer"
                className={`press-scale flex items-center justify-center gap-2 py-3.5 px-4 bg-black text-white rounded-full text-sm font-semibold hover:bg-gray-800 transition-all shadow-soft w-full ${showAndroid ? 'mb-3' : ''}`}
              >
                <AppleIcon />
                <span className="leading-tight">Descarga para iOS</span>
              </a>
            )}
            {showAndroid && (
              <a
                href="https://play.google.com/store/apps/details?id=health.neuron.daisies"
                target="_blank"
                rel="noopener noreferrer"
                className="press-scale flex items-center justify-center gap-2 py-3.5 px-4 bg-[#01875f] text-white rounded-full text-sm font-semibold hover:bg-[#017a55] transition-all shadow-soft w-full"
              >
                <PlayStoreIcon />
                <span className="leading-tight">Descarga para Android</span>
              </a>
            )}
          </div>

          {/* ─── Agenda ahora ─── */}
          <a
            href="https://agenda.daisies.mx/horarios"
            target="_blank"
            rel="noopener noreferrer"
            className="press-scale w-full bg-gradient-to-br from-daisies to-[#9F94E8] text-white rounded-card p-5 shadow-elevated hover:shadow-[0_12px_40px_rgba(120,110,217,0.3)] transition-all animate-fadeInUp-2 group relative overflow-hidden block"
          >
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-white/10 rounded-full blur-2xl" />
            <div className="absolute bottom-0 left-0 w-16 h-16 bg-white/5 rounded-full blur-xl" />
            <div className="relative z-10 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                <Calendar size={24} className="text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-lg font-bold leading-tight">Agenda ahora</p>
                <p className="text-sm text-white/70 font-medium mt-0.5">Consultas de cualquier especialidad</p>
              </div>
              <ChevronRight size={20} className="text-white/60 group-hover:translate-x-1 transition-transform flex-shrink-0" />
            </div>
          </a>

          {/* ─── Tu primer consulta sin costo ─── */}
          <a
            href="https://prueba.daisies.mx"
            target="_blank"
            rel="noopener noreferrer"
            className="press-scale w-full bg-white border border-black/5 rounded-card p-4 shadow-soft hover:shadow-elevated transition-all animate-fadeInUp-3 group flex items-center gap-4"
          >
            <div className="w-10 h-10 rounded-full bg-daisies-50 flex items-center justify-center flex-shrink-0">
              <Sparkles size={20} className="text-daisies" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[15px] font-semibold text-text-primary leading-tight">Tu primer consulta sin costo*</p>
              <p className="text-xs text-text-secondary font-medium mt-0.5">Tu primera experiencia</p>
            </div>
            <ChevronRight size={18} className="text-text-secondary/40 group-hover:translate-x-1 group-hover:text-daisies transition-all flex-shrink-0" />
          </a>

          {/* ─── Checkups de bienestar ─── */}
          <a
            href="https://checkup.daisies.mx"
            target="_blank"
            rel="noopener noreferrer"
            className="press-scale w-full bg-white border border-black/5 rounded-card p-4 shadow-soft hover:shadow-elevated transition-all animate-fadeInUp-4 group flex items-center gap-4"
          >
            <div className="w-10 h-10 rounded-full bg-daisies-50 flex items-center justify-center flex-shrink-0">
              <Heart size={20} className="text-daisies" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[15px] font-semibold text-text-primary leading-tight">Checkups de bienestar</p>
              <p className="text-xs text-text-secondary font-medium mt-0.5">Conoce cómo te sientes</p>
            </div>
            <ChevronRight size={18} className="text-text-secondary/40 group-hover:translate-x-1 group-hover:text-daisies transition-all flex-shrink-0" />
          </a>

          {/* ─── Scroll Arrow ─── */}
          <button
            onClick={scrollToVideo}
            className="mt-2 animate-fadeInUp-5 flex flex-col items-center gap-1 text-text-secondary hover:text-daisies transition-colors cursor-pointer group"
            aria-label="Ver más"
          >
            <span className="text-xs font-medium">Ver más</span>
            <ChevronDown size={24} className="animate-bounce-gentle group-hover:text-daisies" />
          </button>
        </div>
      </div>

      {/* ════════════════════════════════════════════════
          SECTION 2 — Video
       ════════════════════════════════════════════════ */}
      <div
        ref={videoSectionRef}
        className="relative z-10 flex flex-col items-center px-5 py-12 bg-gradient-to-b from-white to-surface"
      >
        <div className="w-full max-w-sm flex flex-col items-center gap-6">

          {/* ─── Video Title ─── */}
          <div className="text-center space-y-3">
            <h2 className="text-2xl font-extrabold text-daisies leading-tight">
              ¿Y SI ESO QUE SIENTES, NO ES "NORMAL"?
            </h2>
            <p className="text-2xl font-extrabold text-text-primary leading-tight">
              TAL VEZ TU CUERPO SOLO TE ESTÁ PIDIENDO QUE LO ESCUCHES
            </p>
          </div>

          {/* ─── Video Player ─── */}
          <div
            className="w-full rounded-card overflow-hidden shadow-elevated bg-black relative cursor-pointer group"
            onClick={handlePlayPause}
          >
            <video
              ref={videoRef}
              src={videoUrl}
              playsInline
              preload="metadata"
              className="w-full aspect-video object-cover"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={() => setIsPlaying(false)}
            >
              Tu navegador no soporta videos.
            </video>

            {/* ─── Custom play overlay ─── */}
            {!isPlaying && (
              <div className="absolute inset-0 bg-daisies/50 flex flex-col items-center justify-center gap-4 transition-opacity">
                <p className="text-white text-sm font-medium text-center px-6 leading-relaxed">
                  Este video puede ayudarte a entenderte.<br />
                  Si lo dejas ahora, seguirás normalizando<br />
                  señales que tu cuerpo lleva tiempo enviando.
                </p>
                <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm text-text-primary font-bold text-sm py-3 px-8 rounded-full shadow-elevated hover:bg-white transition-all">
                  <svg width="14" height="16" viewBox="0 0 14 16" fill="currentColor">
                    <path d="M13.5 8L0.5 15.5V0.5L13.5 8Z" />
                  </svg>
                  REPRODUCIR EL VIDEO
                </div>
              </div>
            )}
          </div>

          {/* ─── Accede a Daisies CTA ─── */}
          <a
            href="https://agenda.daisies.mx/horarios"
            target="_blank"
            rel="noopener noreferrer"
            className="press-scale w-full text-center py-3 rounded-full border-2 border-daisies/20 text-daisies font-semibold text-sm hover:bg-daisies hover:text-white hover:border-daisies transition-all flex items-center justify-center gap-2"
          >
            <Globe size={16} />
            Accede a Daisies
          </a>

          {/* ─── Social Icons ─── */}
          <div className="flex items-center gap-5 mt-2">
            <a
              href="https://www.instagram.com/daisies.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-secondary hover:text-daisies transition-colors"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </a>
            <a
              href="https://www.tiktok.com/@daisies.app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-secondary hover:text-daisies transition-colors"
              aria-label="TikTok"
            >
              <TikTokIcon />
            </a>
            <a
              href="https://www.facebook.com/DaisiesApp/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-secondary hover:text-daisies transition-colors"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>
          </div>

          {/* ─── Footer ─── */}
          <p className="text-[11px] text-text-secondary font-medium mt-2">
            © 2025 Daisies. Todos los derechos reservados.
          </p>
        </div>
      </div>

      {/* ════════════════════════════════════════════════
          SECTION 3 — Horarios disponibles
       ════════════════════════════════════════════════ */}
      <div className="relative z-10 bg-surface py-4">
        <ScheduleSection />
      </div>

      {/* ─── WhatsApp Floating Button ─── */}
      <a
        href="https://api.whatsapp.com/send/?phone=5217778012777&text&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] text-white rounded-full shadow-elevated hover:shadow-[0_8px_32px_rgba(37,211,102,0.4)] hover:scale-105 transition-all flex items-center justify-center"
        aria-label="WhatsApp"
      >
        <WhatsAppIcon />
      </a>
    </div>
  );
}

export default App;
